import { useCallback } from 'react'
import { useMatomo } from '@jonkoops/matomo-tracker-react'
import { Box } from '@mui/material'
import { useForm, useFormState } from 'react-final-form'
import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'

import { ButtonNewest, FormSubmitAction, trackEventFiltered } from '@acre/design-system'

import { messagePrefix } from './ReferClientModal.helpers'

type Props = {
  onClose: () => void
}

const ReferClientModalFooter = ({ onClose }: Props) => {
  const { submitting, pristine, values } = useFormState()
  const { trackEvent } = useMatomo()
  const location = useLocation()
  const form = useForm()

  const handleClose = useCallback(() => {
    onClose()
    form.reset()
  }, [form, onClose])

  const handleSubmit = useCallback(() => {
    trackEventFiltered(trackEvent, location, 'handleClick', 'referForProtection')
    form.reset()
  }, [form, location, trackEvent])

  return (
    <Box width="100%" display="flex" justifyContent="flex-end">
      <Box mr={1}>
        <ButtonNewest
          id="CancelReferProtectionButton"
          disabled={submitting}
          onClick={handleClose}
          variant="secondary"
          color="error"
          size="large"
        >
          <FormattedMessage id={`${messagePrefix}.modal.cancel`} />
        </ButtonNewest>
      </Box>
      <FormSubmitAction
        id="ReferProtectionButton"
        loading={submitting}
        onClick={handleSubmit}
        disabled={pristine || !values.refer_to_firm || (values?.assign_to_advisor && !values?.select_advisor)}
      >
        <FormattedMessage id={`${messagePrefix}.modal.submitDescription`} />
      </FormSubmitAction>
    </Box>
  )
}

export default ReferClientModalFooter
